import { createTheme, ThemeProvider } from "@mui/material";

export const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      ///////// green /////////
      // light: "#00A970",
      // main: "#00704A",
      // dark: "#054534",

      ///////// blue /////////
      light: "#009AC2",
      main: "#0080A1",
      dark: "#004A5E",
      
      contrastText: "#fff",
    },
    secondary: {
      light: "#fafafa",
      main: "#F8F8FA",
      dark: 'gray',
      contrastText: "#000000",
    },
    shadow: {
      main: "rgb(194, 194, 194)",
    },
  },
  typography: {
    fontFamily: "IRANSans",
    fontSize:16
  },
});

export const MuiThemeProivider = (props) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};
